<template>
  <div>
    <img id="smiley" src="../../public/img/smiley.png" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

var requestAnimFrame =
  window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  window.oRequestAnimationFrame ||
  function (callback) {
    window.setTimeout(callback, 1000 / 60)
  }

export default {
  data() {
    return {
      path: process.env.VUE_APP_HOME,
      windowW: 0,
      windowH: 0,
      width: 0,
      height: 0,
      top: 0,
      left: 0,
      xSpeed: 2,
      ySpeed: 1,
      requestID: null,
      startTime: 0,
      delTime: 0,
      mouseTime: 0,
      mouseMove: false,
      rainbow: [
        '#FF0000',
        '#FF1F00',
        '#FF3F00',
        '#FF5F00',
        '#FF7F00',
        '#FF9F00',
        '#FFBF00',
        '#FFDF00',
        '#FFFF00',
        '#DFFF00',
        '#BFFF00',
        '#9FFF00',
        '#7FFF00',
        '#5FFF00',
        '#3FFF00',
        '#1FFF00',
        '#00FF00',
        '#00FF1F',
        '#00FF3F',
        '#00FF5F',
        '#00FF7F',
        '#00FF9F',
        '#00FFBF',
        '#00FFDF',
        '#00FFFF',
        '#00DFFF',
        '#00BFFF',
        '#009FFF',
        '#007FFF',
        '#005FFF',
        '#003FFF',
        '#001FFF',
        '#0000FF',
        '#1F00FF',
        '#3F00FF',
        '#5F00FF',
        '#7F00FF',
        '#9F00FF',
        '#BF00FF',
        '#DF00FF',
        '#FF00FF',
        '#FF00DF',
        '#FF00BF',
        '#FF009F',
        '#FF007F',
        '#FF005F',
        '#FF003F',
        '#FF001F',
      ],
      colorCount: 0,
    }
  },
  created() {
    window.addEventListener('resize', this.init, false)
    window.addEventListener('mousemove', this.remove, false)
  },
  computed: {
    ...mapGetters(['user']),
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.cancelAnimation()

      this.windowW = window.innerWidth
      this.windowH = window.innerHeight

      var smiley = document.getElementById('smiley')

      smiley.style.position = 'absolute'
      smiley.style.zIndex = 101
      smiley.style.width = (this.windowH * 6) / 100 + 'px'

      this.height = this.width = (this.windowH * 6) / 100
      this.top = this.windowH / 2 - (this.windowH * 6) / 100 / 2
      this.left = this.windowW / 2 - (this.windowW * 6) / 100 / 2

      this.startTime = this.delTime = this.mouseTime = Date.now()

      this.loop()
    },
    loop() {
      this.draw()
      this.requestID = requestAnimFrame(this.loop)
    },
    draw() {
      if (this.top < 0) {
        this.ySpeed = -this.ySpeed
      }
      if (this.top + this.height + 2 > this.windowH) {
        this.ySpeed = -this.ySpeed
      }
      if (this.left < 0) {
        this.xSpeed = Math.abs(this.xSpeed)
      }
      if (this.left + this.width > this.windowW - 2) {
        this.xSpeed = -Math.abs(this.xSpeed)
      }

      this.left += this.xSpeed
      this.top += this.ySpeed
      var smiley = document.getElementById('smiley')
      this.dublicate()

      smiley.style.top = this.top + 'px'
      smiley.style.left = this.left + 'px'
    },
    cancelAnimation() {
      if (this.requestID) {
        cancelAnimationFrame(this.requestID)
      }
    },
    dublicate() {
      let delay = this.user.screenSaverTime * 1000
      if (
        Date.now() - this.mouseTime > delay &&
        Date.now() - this.startTime > 300
      ) {
        this.mouseMove = true
        let color = this.rainbow[this.colorCount++]
        var tmpSmiley = document.createElement('div')
        tmpSmiley.style.width = (this.windowH * 6) / 100 + 'px'
        tmpSmiley.style.height = (this.windowH * 6) / 100 + 'px'
        tmpSmiley.style.top = this.top + 'px'
        tmpSmiley.style.left = this.left + 'px'
        tmpSmiley.style.backgroundColor = color + '66'
        tmpSmiley.style.border = '1px solid ' + color + '88'
        // tmpSmiley.style.opacity = 0.5
        tmpSmiley.classList.add('tmpSmiley')
        document.body.appendChild(tmpSmiley)
        this.startTime = Date.now()
      }

      if (this.colorCount == this.rainbow.length - 1) this.colorCount = 0

      if (Date.now() - this.delTime > 1000 && this.mouseMove) {
        document.getElementsByClassName('tmpSmiley').forEach((smile, i) => {
          if (i == 0) document.body.removeChild(smile)
        })
        this.delTime = Date.now()
      }
    },
    remove() {
      this.mouseTime = Date.now()
      if (this.mouseMove) {
        document.getElementsByClassName('tmpSmiley').forEach((smile, idx) => {
          setTimeout(() => {
            document.body.removeChild(smile)
          }, idx * 5)
        })
        this.mouseMove = false
      }
    },
  },
  beforeDestroy() {
    this.cancelAnimation()
  },
}
</script>

<style>
.tmpSmiley {
  position: absolute;
  z-index: 100;
  border-radius: 50%;
}
</style>
